export function isSameOriginTopWindow() {
	try {
		return window.top?.location.host === window.location.host;
	} catch (e) {
		return false;
	}
}
